import { Component as ComponentContainer } from '@styles/layout';
import { GenericComponent } from '@model/content';
import { OrderBrochureFormContainer } from '@components/help';
import { withIsServer } from '@components/hoc';

interface OrderBrochureContainerProps extends GenericComponent {
  isServer: boolean;
}

export const OrderBrochureContainer = withIsServer(({ isServer }: OrderBrochureContainerProps) => {
  if (isServer) {
    return null;
  }

  return (
    <ComponentContainer>
      <OrderBrochureFormContainer />
    </ComponentContainer>
  );
});
